// memoryCharged Reducer
const stateHeadings = {
    rubriques  : [] 
};

export default (state = stateHeadings, action) => {
    switch (action.type) {
        case 'SET_STATE_HEADINGS':
            return {
                ...state,
                rubriques: action.data
            };
        case 'GET_STATE_HEADINGS':
            return {
                ...state,
                rubriques: action.data
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/StateHeadings.js